import {useSelector} from "react-redux";
import React, {memo, useContext, useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import {Context} from "../../context/MainSearchContext";
import {getList} from "../../services/accessoryService";
import {IoAddCircleOutline} from "react-icons/io5";
import Select from "../../components/Select";
import MainSearchInput from "../../components/search/MainSearchInput";
import TemDataTableInline from "../../components/TemDataTableInline";
import Pagination from "../../components/Pagination";
import DeleteButton from "../../components/DeleteButton";
import EditButton from "../../components/EditButton";
import swal from "sweetalert";
import {deleteItem} from "../../services/service";
import {toast} from "react-toastify";
import ModalEditAccessoriesSide from "../../components/accessories/ModalEditAccessoriesSide";

const bodyContent = [
    "id",
    "hangleSide",
    "hangleSideFunc",
    "actions"
];

const headerTable = [{
    name: "id", sort: false
}, {
    name: "side", sort: false
}, {
    name: "value", sort: false
}, <span className="sr-only">Edit</span>];

function AccessoriesSideLayout({selectedId}) {
    const {token} = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [rowSide, setRowSide] = useState(null);

    const {t} = useTranslation();
    const ctx = useContext(Context);

    const fetchData = async () => {
        const responce = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/side/${selectedId}/list`,
            token
        );
        setData(responce.res.map((item, index) => {
            return {
                ...item,
                hangleSideFunc: t(`HangleSideFunc.${item.hangleSideFunc}`),
                actions: (
                    <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                        <EditButton onclick={() => editHandler(item)}/>
                    </div>
                )
            }
        }));
    }

    const sortFunction = (value) => {

    }

    useEffect(() => {
        fetchData();
    }, [selectedId]);

    const editHandler = async (item) => {
        setRowSide(item);
        setOpen(true);
    };

    return (
        <>
            <ModalEditAccessoriesSide open={open} setOpen={setOpen} row={rowSide} fetchData={fetchData}/>
            {isLoading ? (
                <h1>Loading...</h1>
            ) : (
                <>
                    <div className="flex items-center justify-between">
                        <h1 className="text-xl font-semibold text-gray-900">
                            {t(`side_description`)}
                        </h1>
                    </div>

                    <TemDataTableInline
                        data={data}
                        bodyContent={bodyContent}
                        headerTable={headerTable}
                        sortFunction={sortFunction}
                    />

                </>
            )}
        </>
    );
}

export default withTranslation()(memo(AccessoriesSideLayout))